<template>
  <v-row justify="center" class="mt-4">
    <v-col cols="12">
      <span class="text-h5 grey--text">Stampa</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "StampaMobile",
};
</script>
